const PrinterType = {
  PEECHO: 'Peecho',
  HF_GROUP: 'HF Group',
};

module.exports = PrinterType;
